import React, { useEffect, useState } from 'react'
import Modal from 'react-bootstrap/Modal';
import { fetchStlife } from '../services/stlifeService';
import { showLoader, hideLoader } from '../redux/loaderSlice';
import { useDispatch } from 'react-redux';

const Studentlife = () => {
    const dispatch = useDispatch();
    const [stlife, setStlife] = useState([]);
    const [show, setShow] = useState(false);
    const [dir, setDir] = useState('');
    const [images, setImages] = useState([]);
    const [img, setImg] = useState(0);
    const src = "https://images.vardaanschool.org/stlife-images";  

    // useEffect(()=>{
    //   let stlifeList = [
    //     {eventName: 'Independence & Republic Day', dir: 'national', eventImages: ['_DSC0854.JPG', '_DSC0857.JPG', '_MG_8381.JPG', '_MG_8430.JPG', 'DSC_0200.JPG']},
    //     {eventName: 'Fancy Dress', dir: 'fancydress', eventImages: []},
    //     {eventName: 'Janmasthmi', dir: 'janmasthmi', eventImages: []},
    //     {eventName: 'Kids Activity', dir: 'kidsactivity', eventImages: []},
    //     {eventName: 'Scout', dir: 'scout', eventImages: []},
    //     {eventName: 'Sports', dir: 'sports', eventImages: []},
    //     {eventName: 'Summer Camp', dir: 'summercamp', eventImages: []},
    //     {eventName: 'Outdoor Activity', dir: 'outdoor', eventImages: []}
    //   ];
    //   setStlife(stlifeList);
    // }, [])

    useEffect(()=>{
          dispatch(showLoader());
          const getStlife = async ()=>{
            await fetchStlife()
            .then(response=>{
              const list = response.data.list.map(val=> {
                return {title: val.title, slug: val.slug, images: val.images}
              });
              
              setStlife(list);
              dispatch(hideLoader());
            })
            .catch(error=>{
              setStlife([]);
              dispatch(hideLoader());
            });
          }
      
          getStlife();
        }, []);

    const handleClose = () => setShow(false);
    const handleShow = (imgIndex) => {
      setImages(stlife[imgIndex].images);
      setDir(stlife[imgIndex].slug);
      setShow(true);
    };

    const changeImage = (i)=>{
      if(img<=images.length-2 && i===1)
        setImg(img+1);
      if(img>0 && i===-1)
        setImg(img-1);
    }

  return (
    <div>
      <div className='subpages_heading1'>
        <img className='sub_heading_img' src='https://images.vardaanschool.org/used/st_life_heading.webp' alt='about' loading='lazy' />
        <img className='sub_heading_img_mob' src='https://images.vardaanschool.org/used/st_life_heading_mob.webp' alt='about' loading='lazy' />
      </div>           
      <div className='subpages_body'>
        <div className='event_body'>
          {!stlife.length && <div className='cmng_sn'>
            Coming Soon
          </div>}
          {stlife.length && stlife.map((val, i)=>{
              return <div key={`stlife_${i}`} className='event_card' onClick={()=>handleShow(i)}>
                        <div className='thumbnail_box'>
                          <img src={`${src}/${val.slug}/${val.images[0]}`} alt='event_image' className='event_image1' loading='lazy' />
                          <img src={`${src}/${val.slug}/${val.images[1]}`} alt='event_image' className='event_image2' loading='lazy' />
                          <img src={`${src}/${val.slug}/${val.images[2]}`} alt='event_image' className='event_image3' loading='lazy' />
                        </div>
                        <div className='event_name'>
                          {val.title} ({val.images.length})
                        </div>                             
                     </div>
          })}
        </div>
      </div>
        <Modal size="lg" show={show} onHide={handleClose} centered>
          <Modal.Body>
            <div className='modal_image_box'>
              <div className='modal_left_btn' onClick={()=>changeImage(-1)}><img width="30" height="30" src="https://img.icons8.com/ios-glyphs/30/1A1A1A/circled-left.png" alt="circled-left" loading='lazy' /></div>
              <img src={`${src}/${dir}/${images[img]}`} alt='event_image' className='modal_event_image' loading='lazy'/>
              <div className='modal_right_btn' onClick={()=>changeImage(1)}><img width="30" height="30" src="https://img.icons8.com/ios-glyphs/30/1A1A1A/circled-right.png" alt="circled-right" loading='lazy'/></div>
            </div>
          </Modal.Body>
        </Modal>
    </div>
  )
}

export default Studentlife
